import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Button } from '../../common/components';

const PreviewPDF = ({ onCancel, onDownload, file: _file }) => {
  const [numPagesValue, setNumPagesValue] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    document.body.classList.add('hide-overflow');
    return () => document.body.classList.remove('hide-overflow');
  }, []);

  const _onDocumentLoadSuccess = ({ numPages }) => {
    setNumPagesValue(numPages);
  };
  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  return (
    <div className="pdfViewer">
      <div className="buttonParent">
        <Button textTransform="" className="btn-cancel" color="default" onClick={onCancel}>
          CANCEL
        </Button>
        <Button textTransform="" className="btn-dwld" color="default" onClick={onDownload}>
          DOWNLOAD PDF
        </Button>
      </div>
      <div className="pdfRenderer">
        <button
          onClick={previousPage}
          disabled={pageNumber <= 1}
          type="button"
          className="next-pre-btn"
        >
          <i className="fa fa-chevron-left" />
        </button>
        {/* <Document
          file={new Blob([file])}
          onLoadSuccess={onDocumentLoadSuccess}
          renderMode="svg"
        >
          <Page pageNumber={pageNumber} />
        </Document> */}
        <button
          onClick={nextPage}
          disabled={pageNumber >= numPagesValue}
          type="button"
          className="next-pre-btn"
        >
          <i className="fa fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};
PreviewPDF.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  file: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default PreviewPDF;
